import { Box, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { MouseEvent } from 'react';
import { Temporal } from 'temporal-polyfill';
import { IRenderMetadata } from '../../month-calendar.controller';
import { IMonthCalendarEvent } from '../../types/IMonthCalendarEvent';
import CalendarEvent from './components/calendar-event/calendar-event.view';
import DateInfo from './components/date-info.view';

interface IProps {
	/**
	 * True when the user is dragging the mouse to select a range of days.
	 */
	isDragging: boolean;
	events: Array<IMonthCalendarEvent & IRenderMetadata>;
	timeZone: string;
	locale: string;
	plainDate: Temporal.PlainDate;
	onMouseEnter?: (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
	onMouseDown?: (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
	onMouseUp?: (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
	onEventClick: (event: IMonthCalendarEvent) => void;
}

const MAX_VISIBLE_EVENTS = 6;

export default function CalendarDay(props: IProps) {
	return (
		<Box
			role="gridcell"
			aria-labelledby={props.plainDate.toString()}
			onMouseDown={props.onMouseDown}
			onMouseEnter={props.onMouseEnter}
			onMouseUp={props.onMouseUp}
			outlineOffset={0}
			outline=".25px solid var(--chakra-colors-gray-200)"
			display="grid"
			gridTemplateRows="auto 1fr"
			overflow="hidden"
			h="full"
			backgroundColor={props.isDragging ? 'red.100' : 'white'}
			position="relative"
		>
			<DateInfo plainDate={props.plainDate} locale={props.locale} timeZone={props.timeZone} />

			<Box h="auto" display="grid" gridTemplateRows={`repeat(${MAX_VISIBLE_EVENTS}, 1fr)`} gap={0.5}>
				{props.events.map((e) => {
					return (
						<CalendarEvent
							event={e}
							key={e.id}
							locale={props.locale}
							onEventClick={props.onEventClick}
							plainDate={props.plainDate}
							timeZone={props.timeZone}
							metadata={e}
						/>
					);
				})}
				{props.events.length > MAX_VISIBLE_EVENTS ? (
					<Text
						zIndex={3}
						fontSize="x-small"
						textAlign="center"
						color="gray.500"
						bg="rgba(255,255,255, .9)"
						position="absolute"
						bottom={0}
						left={0}
						right={0}
					>
						{t('More events')}
					</Text>
				) : null}
			</Box>
		</Box>
	);
}
